export const AVM = 'avm'
export const WIN = 'win'
export const REFI = 'refi'
export const AIRBNB = 'airbnb'
export const CASHOUT = 'cashout'
export const NET_WORTH = 'net_worth'
export const MAP_PANNED = 'map_panned'
export const MAP_ZOOM_IN = 'zoomed_in'
export const MAP_ZOOM_OUT = 'zoomed_out'
export const TOTAL_COST_ANALYSIS = 'tca'
export const FILTER_SQFT_MIN = 'sqft_min'
export const FILTER_SQFT_MAX = 'sqft_max'
export const FILTER_PRICE_MAX = 'price_max'
export const FILTER_PRICE_MIN = 'price_min'
export const FILTER_BED_MIN = 'bedroom_min'
export const FILTER_BATH_MIN = 'bathroom_min'
export const FILTER_PROPERTY_TYPE = 'home_type'
export const FILTER_YR_MIN = 'construction_year_min'
export const FILTER_YR_MAX = 'construction_year_max'
export const CUSTOM_MARKET_ANALYSIS = 'cma'
export const SHOULD_I_SELL = 'should_i_sell'
export const INSTANT_OFFER = 'instant_offer'
export const PURCHASE_POWER = 'purchase_power'
export const HOME_INSURANCE = 'home_insurance'
export const PRIVATE_MORTGAGE_INSURANCE = 'pmi'
export const CLIENT_SCHEDULED_SHOWING = 'showing'
export const CLIENT_REQUESTED_PREQUAL = 'prequal'
export const REVERSE_MORTGAGE = 'reverse_mortgage'
export const TUNED_VALUE_INCREASE = 'tune_increase'
export const TUNED_VALUE_DECREASE = 'tune_decrease'
export const PRINCIPAL_INTEREST = 'principal_interest'
export const PAY_EXTRA_PRINCIPAL = 'pay_extra_principal'
export const SORT_LISTINGS_BY_PRICE_LOW = 'sort_price_low'
export const SORT_LISTINGS_BY_PRICE_HIGH = 'sort_price_high'
export const SORT_LISTINGS_BY_SQFT_LARGE = 'sort_sqft_largest'
export const SORT_LISTINGS_BY_SQFT_SMALL = 'sort_sqft_smallest'
